import React, { useEffect, useState, useContext } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import invitationService from '../services/invitationService';
import { AuthContext } from './AuthContext';
import { FaTrophy, FaSignInAlt, FaUserPlus, FaGlobe } from 'react-icons/fa';
import '../styles/InvitePage.css';
import InviteSuccess from './InviteSuccess'; // <-- IMPORT NOVÉ KOMPONENTY

const InvitePage = () => {
    const { leagueId, inviteToken } = useParams();
    const { isLoggedIn } = useContext(AuthContext);
    const navigate = useNavigate();
    const { t, i18n } = useTranslation();
    
    const [inviteInfo, setInviteInfo] = useState(null);
    const [status, setStatus] = useState('loading'); 
    const [error, setError] = useState('');
    
    const [showLanguageDropdown, setShowLanguageDropdown] = useState(false);

    useEffect(() => {
        const fetchInviteInfo = async () => {
            try {
                const data = await invitationService.checkInviteToken(inviteToken); 
                setInviteInfo(data);
                setStatus('valid');
            } catch (err) {
                setStatus('invalid');
                setError(t('invite.invalidLink'));
            }
        };
        fetchInviteInfo();
    }, [inviteToken, t]);

    const handleAccept = async () => {
        setStatus('joining');
        try {
            await invitationService.acceptInvite(leagueId, inviteToken);
            setStatus('success');
            setTimeout(() => navigate(`/league/${leagueId}`), 2000);
        } catch (err) {
            setError(t('invite.joinFailed'));
            setStatus('valid');
        }
    };

    const handleAuthRedirect = (path) => {
        localStorage.setItem('pendingInvite', JSON.stringify({ leagueId, inviteToken }));
        navigate(path);
    };

    const changeLanguage = (lng) => {
        i18n.changeLanguage(lng);
        setShowLanguageDropdown(false);
    };

    if (status === 'loading') {
        return (
            <div className="ip-container">
                <div className="ip-loading">{t('loading')}</div>
            </div>
        );
    }

    if (status === 'invalid') {
        return (
            <div className="ip-container">
                <div className="ip-error-box">{error}</div>
            </div>
        );
    }

    return (
        <div className="ip-container">
            {/* Přepínač jazyků */}
            <div className="ip-language-selector">
                <button 
                    className="ip-language-toggle-btn"
                    onClick={() => setShowLanguageDropdown(!showLanguageDropdown)}
                    title={t('languageChange')}
                >
                    <FaGlobe />
                </button>

                {showLanguageDropdown && (
                    <div className="ip-language-dropdown">
                        <div className="ip-language-option" onClick={() => changeLanguage('cs')}>
                            <span style={{ marginRight: '8px' }}>🇨🇿</span> Česky
                        </div>
                        <div className="ip-language-option" onClick={() => changeLanguage('en')}>
                            <span style={{ marginRight: '8px' }}>🇬🇧</span> English
                        </div>
                    </div>
                )}
            </div>

            <div className="ip-card">
                {/* Pokud je úspěch, zobrazíme reusable komponentu */}
                {status === 'success' ? (
                    <InviteSuccess />
                ) : (
                    <>
                        <div className="ip-header">
                            <div className="ip-icon-placeholder">
                                <FaTrophy />
                            </div>
                        </div>

                        <div className="ip-content">
                            <span className="ip-subtitle">
                                {t('invite.invitedTo')}
                            </span>
                            <h1 className="ip-league-name">{inviteInfo?.leagueName || 'Unknown League'}</h1>

                            {inviteInfo?.tournamentName && (
                                <div className="ip-tournament-badge">
                                    {inviteInfo.tournamentName
                                      ? t(`tournaments.${inviteInfo.tournamentName}`, { year: inviteInfo.tournamentYear })
                                      : t('noTournament')}
                                </div>
                            )}
                            
                            <div className="ip-details-badge">
                                {t('invite.creator')}: <strong>{inviteInfo?.ownerName}</strong>
                            </div>
                            
                            {isLoggedIn ? (
                                <div className="ip-actions">
                                    <button 
                                        className="ip-btn ip-btn-primary" 
                                        onClick={handleAccept}
                                        disabled={status === 'joining'}
                                    >
                                        {status === 'joining' 
                                            ? t('invite.joining') 
                                            : t('invite.accept')
                                        }
                                    </button>
                                    <button 
                                        className="ip-btn ip-btn-ghost" 
                                        onClick={() => navigate('/dashboard')}
                                    >
                                        {t('invite.cancel')}
                                    </button>
                                </div>
                            ) : (
                                <div className="ip-auth-box">
                                    <p className="ip-auth-text">
                                        {t('invite.authPrompt')}
                                    </p>
                                    <div className="ip-actions">
                                        <button className="ip-btn ip-btn-primary" onClick={() => handleAuthRedirect('/login')}>
                                            <FaSignInAlt /> {t('signIn')}
                                        </button>
                                        <button className="ip-btn ip-btn-secondary" onClick={() => handleAuthRedirect('/register')}>
                                            <FaUserPlus /> {t('noAccountRegister')}
                                        </button>
                                    </div>
                                </div>
                            )}
                        </div>
                    </>
                )}
            </div>
        </div>
    );
};

export default InvitePage;